module.exports = {

    // NAV
    UPDATE_STICKY: 'update_sticky',
    UPDATE_SHADOW: 'update_shadow',
    UPDATE_MENU: 'update_menu',
    UPDATE_PAGEREF: 'update_pageref',
    UPDATE_PAGEFOCUSMENU: 'update_pagefocusmenu',
    UPDATE_GOBACKLINK: 'update_goBackLink',
    UPDATE_EXPANDMENU: 'update_expandMenu',
    UPDATE_ACTIVECOMPANY: 'update_activeCompany',

    // AUTH
    AUTH_USER: 'auth_user',
    AUTH_ERROR: 'auth_error',

    CREATE_CARD: 'create_card',
    LOAD_DISPLAY_PICTURE: 'load_display_picture'

}

